export default "<center>6</center>\n<br>\n<br>\n";